// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .left {
  max-width: 151px;
  margin-right: 9px;
  float: left;
}
:host .right {
  float: left;
  width: calc(100% - 162px);
}
:host .active ion-card-content {
  transform: translateY(0%) !important;
  padding-bottom: 56px;
}
:host .line2 {
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.76);
}
:host .line {
  position: absolute;
  top: 5px;
  left: 50%;
  border-top: 2px solid #2a2c32;
  width: calc(100% - 30px);
  transform: translateX(-50%);
  margin-top: 20px;
  margin-bottom: 20px;
}
:host .title {
  position: relative;
  left: 50%;
  margin-top: 5%;
  margin-bottom: 0;
  transform: translateX(-50%);
  display: inline-block;
  padding: 1px 10px 0;
  max-width: 80%;
  width: auto;
}
:host ion-badge {
  display: flex;
  align-items: center;
}
:host .tool {
  height: 18px;
  position: absolute;
  bottom: 0;
  width: 100%;
}
:host .btn {
  position: relative;
  left: 50%;
  bottom: 0;
  transform: translateX(-80%) translateY(-20px);
  -webkit-transform: translateX(-80%) translateY(-20px);
  border-radius: 4px 4px 0 0;
  border: none;
  text-transform: uppercase;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.075em;
  z-index: 100;
}
:host .star {
  position: absolute;
  top: 0px;
  z-index: 9;
}
:host ion-card-content {
  background: var(--my-custom-primary);
  position: absolute;
  bottom: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  transform: translateY(100%);
  transition: all 500ms;
  padding: 5px;
}
:host h1, :host h2, :host h3, :host h4, :host h5, :host h6 {
  color: var(--ion-color-primary);
}
:host p {
  color: white !important;
  font-size: 14px;
}
:host span {
  color: var(--ion-color-primary) !important;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-card1/custom-card1.component.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;AAAJ;AAGE;EACE,WAAA;EACA,yBAAA;AADJ;AAKI;EACE,oCAAA;EACA,oBAAA;AAHN;AAME;EACE,mBAAA;EACA,SAAA;EACA,+CAAA;AAJJ;AAME;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;EACA,wBAAA;EACA,2BAAA;EACA,gBAAA;EACA,mBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,qBAAA;EACA,mBAAA;EAEA,cAAA;EACA,WAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;AAPJ;AAUE;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AARJ;AAWE;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,6CAAA;EACA,qDAAA;EACA,0BAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;AATJ;AAYE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAVJ;AAcE;EACE,oCAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EAEA,qBAAA;EACA,YAAA;AAZJ;AAcE;EACE,+BAAA;AAZJ;AAeE;EAEE,uBAAA;EACA,eAAA;AAdJ;AAgBE;EACE,0CAAA;EACA,eAAA;AAdJ","sourcesContent":[":host {\n  .left {\n    max-width: 151px;\n    margin-right: 9px;\n    float: left;\n  }\n\n  .right {\n    float: left;\n    width: calc(100% - 162px);\n  }\n\n  .active {\n    ion-card-content {\n      transform: translateY(0%) !important;\n      padding-bottom: 56px;\n    }\n  }\n  .line2 {\n    margin-bottom: 1rem;\n    border: 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.76);\n  }\n  .line {\n    position: absolute;\n    top: 5px;\n    left: 50%;\n    border-top: 2px solid #2a2c32;\n    width: calc(100% - 30px);\n    transform: translateX(-50%);\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n\n  .title {\n    position: relative;\n    left: 50%;\n    margin-top: 5%;\n    margin-bottom: 0;\n    transform: translateX(-50%);\n    display: inline-block;\n    padding: 1px 10px 0;\n    //margin: auto;\n    max-width: 80%;\n    width: auto;\n  }\n\n  ion-badge {\n    display: flex;\n    align-items: center;\n  }\n\n  .tool {\n    height: 18px;\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n  }\n\n  .btn {\n    position: relative;\n    left: 50%;\n    bottom: 0;\n    transform: translateX(-80%) translateY(-20px);\n    -webkit-transform: translateX(-80%) translateY(-20px);\n    border-radius: 4px 4px 0 0;\n    border: none;\n    text-transform: uppercase;\n    font-weight: 700;\n    line-height: 20px;\n    letter-spacing: .075em;\n    z-index: 100;\n  }\n\n  .star {\n    position: absolute;\n    top: 0px;\n    z-index: 9;\n  }\n\n\n  ion-card-content {\n    background: var(--my-custom-primary);\n    position: absolute;\n    bottom: 0;\n    z-index: 10;\n    width: 100%;\n    height: 100%;\n    transform: translateY(100%);\n    -webkit-transition: all 500ms;\n    transition: all 500ms;\n    padding: 5px;\n  }\n  h1, h2, h3, h4, h5, h6 {\n    color: var(--ion-color-primary);\n  }\n  \n  p\n  {\n    color: white !important ;\n    font-size: 14px;\n  } \n  span {\n    color: var(--ion-color-primary) !important ;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
